import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { firstMap } from "keautils";
import { SelectQueryProps, SelectQueryViewProps, SelectQueryViewPropsRx } from "kea-react/dist/selector/query";
import { observeResource } from "kea-resource";
import { validarIdentificacion } from "app/logic/cliente";
import { IdentificacionComponent } from "app/features/componentes/cliente/identificacion";
import { DatosFacturacionComponent } from "app/features/componentes/cliente/datosFacturacion";
import { FiltroCliente } from "app/models/requireme";
import { DatosFacturacionCliente, validarDatosFacturacion } from "../../general/catalogos/items/clientes/edit/componentes";

type Entity = models.Cliente;
export interface ClienteEditProps extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
* Modal de edición para un Cliente
*/
class ClienteEdit extends React.PureComponent<ClienteEditProps> {
    value = (props: ClienteEditProps) => props.value;
    datosRep = createSelectorRx(this.value, x => ({ idCliente: x.IdRegistro }));
    errors = createSelectorRx(this.value, this.datosRep, (value, datosRep) => {
        const rules: validation.Rules<Entity> = {
            Nombre: validation.required,
            IdentificacionCliente: x => validarIdentificacion(x.IdentificacionCliente, datosRep, resources.Cliente)
        };
        return validation.getErrors(rules, value);
    });
    getField = formfields(() => this.props, () => this.errors(this.props));

    hasError = createSelectorRx(this.errors, err => validation.hasError(err));
    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const Text = getField(kea.Text);
        const Checkbox = getField(kea.Checkbox);
        const DateTime = getField(kea.DateTime);
        const hasError = this.hasError(this.props);
        const Identificacion = getField(IdentificacionComponent);
        const CodigoRegimenFiscal = getField(DatosFacturacionComponent);

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Crear cliente"
            >
                {kea.autogrid(6, [
                    <Text field="Nombre" />,
                    <Checkbox field="AceptaFletePorCobrar" label="Acepta flete por cobrar" />,                    
                ])}

                <Identificacion field="IdentificacionCliente" datosRep={this.datosRep(this.props)} resourceRep={resources.Cliente} />

                <CodigoRegimenFiscal field="DatosFacturacion" />
            </kea.Modal>
        )
    }
}

export class ClienteItem extends React.PureComponent<{ value: models.ClienteView }> {
    render() {
        const x = this.props.value;
        const direccion = x.PrimeraDireccion;
        const facturacion = x.DireccionFacturacion;
        return (
            <div>
                <span>
                    <i className={fa("address-book", "fw")} />
                    <label>{x.Nombre}</label>
                </span>
                <br />
                {
                    direccion &&
                    <span>
                        <i className={fa("map-marker", "fw")} />
                        {direccion}
                    </span>
                }
                <br />
                {
                    facturacion &&
                    <span>
                        <i className={fa("credit-card", "fw")} />
                        {facturacion}
                    </span>
                }
                <br />
                {
                    x.LimiteCredito &&
                    <span>
                        <i className={fa("dollar", "fw")} />
                        <b>{kea.formatCurrency(x.SaldoCredito)}</b> / {kea.formatCurrency(x.LimiteCredito)}
                    </span>
                }
            </div>
        )
    }
}

function mapSelectItem(x: models.ClienteView): kea.SelectorElement {
    return {
        value: x.IdCliente,
        label: x.Nombre,
        view: <ClienteItem value={x} />
    }
}

export interface SelectorClienteProps extends SelectQueryViewPropsRx {
    /**Filtro extra para el selector de clientes */
    filtro?: FiltroCliente;
}

 class ClienteNoRx extends React.PureComponent<SelectorClienteProps> {
    modalManager = kea.createModalManager();

    filtro = (props: SelectorClienteProps) => props.filtro || {};
    readOnly = (props: SelectorClienteProps) => props.readonly;

    loadItems = createSelectorRx(this.filtro,
        filtro => kea.loadSelectorItemsFuncFromResource(busqueda => observeResource(resources.Cliente.Query, {
            Nombre: busqueda,
            Limite: 50,
            EsDeCredito: null,
            ...filtro,
        }), id => observeResource(resources.Cliente.GetClienteView, id), mapSelectItem)
    )

    onAgregar = async () => {
        const result = await this.modalManager.showModal(ClienteEdit, {}, { FechaDeInicioParaComisiones: new Date, AceptaFletePorCobrar: true
        , SeguroViaje:true, NumeroPoliza:"", ImprimirPrecioGuia: true } as models.Cliente);
        if (result.result) {
            const cliente: models.Cliente = {
                ...result.value,
                FechaDeInicioParaComisiones: new Date()
            };

            const id = await resources.Cliente.add(cliente);
            if (this.props.onChange)
                this.props.onChange(id);
        }
    }

    render() {
        const loadItemsFunc = this.loadItems(this.props);
        return (
            <div>
                <kea.SelectQuery label="Cliente" loadItems={loadItemsFunc} onAgregar={this.onAgregar} {... this.props} />
                {this.modalManager.component}
            </div>
        );
    }
}

export const Cliente = componentToRx(ClienteNoRx);


// WEBPACK FOOTER //
// ./app/features/selectores/items/cliente.tsx